import React from 'react'

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HeroImg2 from '../components/HeroImg2';
import PricingCard from '../components/PricingCard';
import Work from '../components/Work';


const Project = () => {
  return (
    <div id="project-top">
      <Navbar />
      <HeroImg2 heading="portfolio" text="highlights of my recent work." />
      <Work />

      {/* 
      <Footer /> */}
    </div>
  )
}

export default Project